export default [{
    path: '/about',
    name: 'about',
    meta: {
        title: '关于我们',
        track: {
            evt: 'CASH_ABOUT',
            label: ''
        }
    },
    component: resolve => require.ensure([], () => resolve(require('../pages/about/index.vue')), 'about'),
    children: [{
        path: 'intro',
        name: 'intro',
        meta: {
            title: '关于我们',
            track: {
                evt: 'CASH_INTRO',
                label: ''
            }
        },
        component: resolve => require.ensure([], () => resolve(require('../pages/about/intro.vue')), 'intro')
    },{
        path: 'milestone',
        name: 'milestone',
        meta: {
            title: '关于我们',
            track: {
                evt: 'CASH_MILESTONE',
                label: ''
            }
        },
        component: resolve => require.ensure([], () => resolve(require('../pages/about/milestone.vue')), 'milestone')
    }]
}];


// WEBPACK FOOTER //
// ./src/routes/about.js